<script>
import { mergeData } from 'vue-functional-data-merge';
const VEntry = () => import('./Entry');

export default {
  name: 'DescriptionListEntryNumber',

  functional: true,

  props: {
    currency: {
      type: [Boolean, String],
      required: false,
      default: false,
    },

    currencyField: {
      type: String,
      required: false,
      default: null,
    },

    digits: {
      type: Number,
      required: false,
      default: null,
    },

    divide: {
      type: Number,
      required: false,
      default: 1,
    },

    data: {
      type: [Array, Object],
      required: false,
      default: null,
    },

    separator: {
      type: String,
      required: false,
      default: '.',
    },

    suffix: {
      type: String,
      required: false,
      default: '',
    },
  },

  render(h, { props, data, children, parent }) {
    const componentData = {
      scopedSlots: {},
      props,
    };

    componentData.scopedSlots.default = ({ value }) => {
      if (value === null || value === '' || isNaN(value)) return;
      let { currency } = props;

      if (props.currencyField) {
        try {
          currency = props.currencyField
            .replace('[', props.separator)
            .replace(']', '')
            .split(props.separator)
            .reduce((obj, property) => obj[property], props.data);
        } catch (err) {}
        if (!currency) currency = true; // fallback to empty currency
      }

      value = value / props.divide;

      let digits = props.digits;

      if (!currency) {
        if (digits === null) {
          return (
            new Intl.NumberFormat(parent.$i18n.locale, {
              style: 'decimal',
            }).format(value) + props.suffix
          );
        } else {
          return (
            new Intl.NumberFormat(parent.$i18n.locale, {
              style: 'decimal',
              minimumFractionDigits: digits,
              maximumFractionDigits: digits,
            }).format(value) + props.suffix
          );
        }
      }

      if (digits === null) digits = 2; // default only for currency

      if (currency === true) {
        return (
          new Intl.NumberFormat(parent.$i18n.locale, {
            style: 'decimal',
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
          }).format(value) + props.suffix
        );
      } else {
        return (
          new Intl.NumberFormat(parent.$i18n.locale, {
            style: 'currency',
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
            currency,
          }).format(value) + props.suffix
        );
      }
    };

    return h(VEntry, mergeData(data, componentData), children);
  },
};
</script>
